// extracted by mini-css-extract-plugin
export default {"BackgroundWrapper":"homePageBackground_BackgroundWrapper__i6C-g","BackgroundImage":"homePageBackground_BackgroundImage__MEbKA"};